/**
 * Chats Query Keys Factory
 * Centralized query key generation for chats-related queries
 * Used by query stores, cache helpers, and middleware
 */

/**
 * Chats query keys factory - single source of truth for all chat query keys
 */
export const chatsQueryKeys = {
  all: (locationId?: string) => ['chats', locationId] as const,
  conversations: (locationId?: string) => ['chats', locationId, 'conversations'] as const,
  conversationsList: (locationId?: string, unread?: boolean) => ['chats', locationId, 'conversations', 'list', { unread }] as const,
  conversation: (locationId?: string, conversationId?: string) => ['chats', locationId, 'conversation', conversationId] as const,
  messages: (locationId?: string, conversationId?: string) => ['chats', locationId, 'messages', conversationId] as const,
  unreadCount: (locationId?: string) => ['chats', locationId, 'unreadCount'] as const,
  suggestions: (locationId?: string, query?: string) => ['chats', locationId, 'suggestions', query] as const,
} as const
